import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ScenarioResponseDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { DragListCardSettings } from '@common-modules/shared/core/drag-list-card/drag-list-card-settings';
import { DragListCustomSettings } from '@common-modules/shared/core/drag-list-custom/drag-list-custom-settings';
import { ScenarioItem } from '../scenario-item';

const COMPONENT_SELECTOR = 'wlm-scenarios-selector';
@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './scenarios-selector.component.html',
  styleUrl: './scenarios-selector.component.scss',
  standalone: false,
})
export class ScenariosSelectorComponent {
  private _scenarios: ScenarioResponseDto[];
  public get scenarios(): ScenarioResponseDto[] {
    return this._scenarios;
  }
  @Input() public set scenarios(value: ScenarioResponseDto[]) {
    this._scenarios = value ?? [];
  }
  @Input() map;

  @Output() scenarioVisibilityChange = new EventEmitter<ScenarioItem>();

  T_SCOPE = '';

  settingsCustom: DragListCustomSettings;
  cardSettings: DragListCardSettings;

  constructor() {}

  ngOnInit(): void {
    this.settingsCustom = new DragListCustomSettings({
      hideFilter: true,
      emptyLegendKey: this.T_SCOPE + '.messages.drag-list-empty-message',
      isReadOnly: false,
    });
  }

  onDroppedElement(e) {}

  onScenarioVisibilityChange(scenario: ScenarioItem): void {
    this.scenarioVisibilityChange.emit(scenario);
  }
}
